module.exports = __webpack_public_path__ + "static/clip-1-d92188e66339d9780008df886657cc74.jpg";